/**
 * Join class names, dropping the falsy ones.
 *
 * No `clsx`, no `tailwind-merge`. The merge libraries exist to referee two conflicting
 * utilities arriving from different places, and the components here do not let that happen
 * -- each one resolves its own variants into a single non-conflicting set (see `Button`)
 * and appends the caller's `className` last, which is where a deliberate override belongs.
 * A dependency that reorders class strings at runtime, on every render, to fix a problem
 * the components do not have would be paying twice.
 */
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(" ");
}
